<ng-container *ngIf="!isLogin">
  <case-top-menu
    [ngClass]="{ 'is-collapsed': isCollapsed }"
    [links]="topMenuLinks"
    [isStaging]="isStaging"
    *ngIf="!isTouchResolution"
  ></case-top-menu>
  <case-touch-menu
    *ngIf="isTouchResolution"
    [menuItems]="menuItems"
    [menuSections]="menuSections"
  ></case-touch-menu>
  <div class="collapse-button" *ngIf="!isTouchResolution">
    <a
      role="button"
      class="navbar-burger burger ghost"
      aria-label="menu"
      aria-expanded="false"
      data-target="navbarBasicExample"
      (click)="isCollapsed = !isCollapsed"
    >
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
      <span aria-hidden="true"></span>
    </a>
  </div>
</ng-container>

<case-flash-message></case-flash-message>

<!--  Main Content -->
<div class="wrapper" [ngClass]="{ 'is-collapsed': isCollapsed }">
  <div class="columns">
    <aside
      #menuList
      class="column aside menu px-0"
      *ngIf="!isLogin && !isTouchResolution"
    >
      <case-side-menu
        [path]="path"
        [isCollapsed]="isCollapsed"
        [menuItems]="menuItems"
        [menuSections]="menuSections"
      ></case-side-menu>
    </aside>
    <div class="column main">
      <main>
        <router-outlet></router-outlet>
      </main>
    </div>
  </div>
</div>

<case-footer></case-footer>
